<template>
  <div class="content">
    <h2>Définition</h2>
    <b-notification :closable="false">
      <p>
        <i>{{ $t('compTransitionDocsCharter.one-structure') | capitalize }}</i>
        en transition est
        {{ $t('compTransitionDocsCharter.one-structure') }} qui a entrepris une
        démarche d’estimation et d’analyse de l’empreinte environnementale de
        ses activités, avec l’objectif de la réduire durablement.
        {{ $t('compTransitionDocsCharter.any-structure') | capitalize }}
        souhaitant s’engager dans une démarche de réduction de ses émissions de
        GES et de son empreinte environnementale peut ainsi rejoindre le réseau
        des {{ $t('compTransitionDocsCharter.structures') }} en transition.
      </p>
      <p>
        Cette charte a pour ambition de faciliter l’appropriation des valeurs du
        réseau décrites ci-dessous et leur application par chacun de ses
        membres. En adoptant cette charte, et avec l’accord de sa direction ,
        chaque {{ $t('compTransitionDocsCharter.structure') }} membre du réseau
        est appelé à adhérer et respecter ces valeurs.
      </p>
    </b-notification>

    <br />
    <h2>Valeurs</h2>
    <br />
    <b-notification :closable="false">
      Les valeurs portées par le réseau sont les suivantes :
      <ul>
        <li>
          <p>
            <b>Partage</b> (entendu comme de l’entraide, du retour d’expérience,
            de la progression collective, de la mutualisation), des expériences
            réussies et de celles moins réussies, des freins et leviers à la
            mise en place de mesures ambitieuses ;
          </p>
        </li>
        <li>
          <p>
            <b>Transparence</b> (entendue aussi comme confiance), dans la mise
            en place de discussions et dans la promotion de pratiques qui
            intègrent la question de l’impact environnemental ;
          </p>
        </li>
        <li>
          <p>
            <b>Respect</b>
            des éventuelles craintes qu’une telle transition peut engendrer dans
            {{ $t('compTransitionDocsCharter.thes-structures') }}.
          </p>
        </li>
      </ul>
    </b-notification>
    <br />

    <h2>Missions</h2>
    <br />
    <b-notification :closable="false">
      Le réseau se donne plusieurs missions avec pour objectif principal de
      soutenir la démarche de Labos 1point5 dans l’ESR :
      <ul>
        <li>
          <p>
            <b>Favoriser</b> les échanges à propos des pratiques vertueuses au
            plan environnemental : partager ce qui est fait par les membres du
            réseau par des retours d’expérience ;
          </p>
        </li>
        <li>
          <p>
            <b>Promouvoir</b> les pratiques vertueuses au plan environnemental
            et les défendre (recueil de bonnes pratiques, communication des
            pratiques, etc.) ;
          </p>
        </li>
        <li>
          <p>
            <b>Faciliter</b> le « passage à l’action » des
            {{ $t('compTransitionDocsCharter.structures') }} une fois les bilans
            des émissions de gaz à effet de serre réalisés ;
          </p>
        </li>
        <li>
          <p>
            <b>Faire de la veille</b> sur les pratiques vertueuses au plan
            environnemental en-dehors du réseau aussi (par exemple, à
            l’étranger, dans la littérature scientifique ou grise).
          </p>
        </li>
      </ul>
      <p>
        {{ $t('compTransitionDocsCharter.thes-structures') }} rejoignant le
        réseau sont incités à faire leur bilan GES sur au moins une année, ils
        peuvent détailler les actions mises en œuvre pour réduire leur empreinte
        environnementale sur la plateforme prévue à cet effet et échanger avec
        les autres membres du réseau.
      </p>
    </b-notification>
    <br />

    <h2>Membres du réseau</h2>
    <br />
    <b-notification :closable="false">
      {{ $t('compTransitionDocsCharter.one-structure') | capitalize }} membre du
      réseau des {{ $t('compTransitionDocsCharter.structures') }} en transition
      peut participer, par l’intermédiaire de ses représentants, à tous les
      projets proposés par le réseau :
      <ul>
        <li>
          <p>Partage d'expérience</p>
        </li>
        <li>
          <p>
            Animation ou participation aux actions du réseau (groupe de travail,
            formation, rédaction d’articles, participation aux études internes,
            réponse aux enquêtes, etc.) ;
          </p>
        </li>
        <li>
          <p>
            Expression de besoins, de suggestions, de pistes d’améliorations ;
          </p>
        </li>
        <li>
          <p>Discussions sur le canal picateam « Transition 1point5 » ;</p>
        </li>
        <li>
          <p>Présentation du réseau (séminaires, AG, etc.) ;</p>
        </li>

        <li>
          <p>
            Offre d’accompagnement d’un
            {{ $t('compTransitionDocsCharter.structure') }}.
          </p>
        </li>
      </ul>
      <p>
        L’adhésion au réseau signifie s’impliquer activement chaque année dans
        une ou plusieurs actions de partage et d’entraide proposées par le
        réseau. En effet, le réseau n’existe que si une partie significative de
        ses membres contribuent à sa vitalité.
      </p>
    </b-notification>

    <h2>La cellule d'animation</h2>
    <br />
    <p>
      Le réseau est doté d’une cellule d’animation, qui est en charge de
      l’animation, de la stimulation des échanges et partages et,
      collégialement, de la modération des actions soumises par un
      {{ $t('compTransitionDocsCharter.structure') }}. Cette cellule d’animation
      est chargée de :
    </p>
    <b-notification :closable="false">
      <ul>
        <li>
          <p>
            Organiser les actions du réseau (réunions plénières, journées,
            événements, etc.) et favoriser la bonne circulation des
            informations;
          </p>
        </li>
        <li>
          <p>
            Modérer collégialement les actions soumises par un
            {{ $t('compTransitionDocsCharter.structure') }} dans la plateforme ;
          </p>
        </li>
        <li>
          <p>
            Coordonner et aider à la construction d’une bibliothèque de
            ressources dédiées aux actions de réduction de l’empreinte
            environnementale ;
          </p>
        </li>
        <li>
          <p>
            Réaliser le suivi du réseau en effectuant un bilan annuel et en
            recensant les besoins des membres du réseau ;
          </p>
        </li>
        <li>
          <p>
            Animer et soutenir la dynamique du réseau et développer le sentiment
            d’appartenance ;
          </p>
        </li>

        <li>
          <p>
            Représenter le réseau et faire le lien avec le GDR Labos 1point5 et
            les institutions.
          </p>
        </li>
      </ul>
    </b-notification>
  </div>
</template>

<script>
export default {
  name: 'Labos1point5Charter'
}
</script>

<style scoped>
h2 {
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  line-height: 1px;
  margin: 0 0 5px 0;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #aaaaaa;
  font-family: 'Poppins', sans-serif;
}

h2::after {
  content: '';
  width: 120px;
  height: 1px;
  display: inline-block;
  background: #6c8fd6;
  margin: 4px 10px;
}
</style>
